export async function readFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    let fr = new FileReader()

    fr.onload = () => {
      resolve((fr.result || '').toString())
    }

    fr.onerror = reject

    fr.readAsText(file)
  })
}

export async function readAsBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    let fr = new FileReader()

    fr.onload = () => {
      resolve((fr.result || '').toString())
    }

    fr.onerror = reject

    fr.readAsDataURL(file)
  })
}
